<!-- begin #footer -->
<div id="footer" class="footer">
    <div class="row">
        <div class="col-12">
            <img src="/images/Viterra_Logo_Black.png?v=2" class="footer-logo"> <span class="k-display-inline-block">&copy; {{Year}} - Viterra USA Ag Holdings, LLC</span>
        </div>
    </div>
</div>
<!-- end #footer -->
